import React, { useEffect, useState } from 'react'
import { message } from 'antd'
import { CreateOrderJavaHttpHS, createPayHS, getPreBalanceAmtHS, orderCancelHS } from 'src/commons/store/UserStore'
import { getPhpToken } from 'src/pc/utils/auth'
import { checkOrderPayStatus, checkRechargeOrderPayStatus } from 'src/pc/store/UserStore'

let StopOrder: Function | null = null
const useCreateOrderAndPay = (PayWay: TPayWay, onlyPay?: boolean, isRecharge?: boolean) => {
  const [createOrderLoading, setCreateOrderLoading] = useState<boolean>(false)
  const [OrderPayVisible, setOrderPayVisible] = useState(false)
  const [payUrl, setPayUrl] = useState<string>('')
  const [orderNo, setOrderNo] = useState<string>('')
  const [payAmt, setPayAmt] = useState<number>()

  const OrderCancel = () => {
    setOrderPayVisible(false)
    StopOrder?.()
    setPayAmt(undefined)
  }
  const orderCancelReal = () => {
    try {
      orderCancelHS.Execute({ orderNo })
    } catch (error) {
      message.warn(error.message)
    }
  }
  const getPayMode = () => {
    // if (payAmt > 0) {
    const payMap = {
      wechat: 'wechat_scan',
      alipay: 'alipay_scan',
      qq_wallet: 'qq_scan',
      balance: 'yue',
    }
    return payMap[PayWay]
    // }
    // return 'yue'
  }

  useEffect(() => {
    return () => {
      OrderCancel()
    }
  }, [])

  const createJavaOrder = async (
    params: CreateOrderBoxWebQuery,
    onSuccess: (orderData?: CreateOrderBoxWeb, result?: CheckGameOrderStatus) => void,
    onError?: (err: any) => void,
    hookCreateOrderSuccess?: () => void,
  ) => {
    let orderData: CreateOrderBoxWeb
    const Authorization = getPhpToken()
    setCreateOrderLoading(true)
    try {
      orderData = await CreateOrderJavaHttpHS.Execute(
        { ...params, payMode: getPayMode() },
        {
          headers: {
            Authorization,
          },
        },
      )
    } catch (e) {
      console.log('orderData err', e)
      setCreateOrderLoading(false)
      message.warning(e.message)
      onError && onError(e)
      return
    }
    hookCreateOrderSuccess?.()
    // console.log('orderData', orderData)
    const token = getPhpToken() || ''
    setPayAmt(orderData.payAmt)
    //余额支付，
    if (orderData.payAmt <= 0) {
      onSuccess(orderData)
      setCreateOrderLoading(false)
      return
    }

    let qrRes
    try {
      qrRes = await createPayHS.Execute(
        {
          balanceNo: orderData.balanceNo,
          payMode: getPayMode(),
        },
        {
          headers: {
            Authorization,
          },
        },
      )
    } catch (e) {
      console.log('pay err', e)
      message.warning(e.message)
      setCreateOrderLoading(false)
      onError && onError(e)
      return
    }
    setCreateOrderLoading(false)
    //第三方支付
    setPayUrl(qrRes)
    setOrderNo(orderData.orderNo)
    setOrderPayVisible(true)
    if (onlyPay) {
      onSuccess(orderData)
      return
    }
    StopOrder?.()
    if (isRecharge) {
      StopOrder = checkRechargeOrderPayStatus(
        { orderNo: orderData.orderNo },
        data => {
          setOrderPayVisible(false)
          onSuccess()
        },
        () => {
          onError?.({})
          message.warning('支付订单超时!')
          // orderCancelReal()
          OrderCancel()
        },
      )
      return
    }
    StopOrder = checkOrderPayStatus(
      { token, order_no: orderData.orderNo },
      data => {
        setOrderPayVisible(false)
        onSuccess(orderData, data)
      },
      () => {
        onError?.({})
        message.warning('支付订单超时!')
        // orderCancelReal()
        OrderCancel()
      },
    )
  }

  const getPreViewPrice = async (params: CreateOrderBoxWebQuery) => {
    const price = await getPreBalanceAmtHS.Execute({
      ...params,
      payMode: getPayMode(),
    })
    return price
  }

  return {
    createOrderLoading,
    OrderPayVisible,
    payUrl,
    createJavaOrder,
    OrderCancel,
    orderCancelReal,
    getPreViewPrice,
    setPayAmt,
    payAmt,
  }
}

export default useCreateOrderAndPay
